import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { SignedIn, SignedOut } from "@clerk/clerk-react";

// Pages ADMIN
import DashboardPage from "../admin/DashboardPage";
import TransactionsPageAdmin from "../admin/TransactionsPageAdmin";
import CustomerPage from "../admin/Account/CustomerPage";
import GestionTitle from "../admin/Titles/GestionTitle";
import OrderPageAdmin from "../admin/Order/OrderPageAdmin";
import EventLiason from "../Events/EventLiason";

// Pages CLIENT
import DashboardClient from "../Clients/DashboardClient";
import AideClient from "../Clients/AideClient";
import OrderPage from "../Clients/OrdersPage";
import TransactionsPage from "../Clients/TransactionsPage";
import Securities from "../Clients/Securities";
import CompletRfi from "../admin/RFIS/CompletRfi";
import EditProfile from "../Shared/EditProfile";

// Pages SUPER ADMIN
import Dashboard from "../SuperAdmin/Dashboar";

// Pages PARTAGÉES
import PageError404 from "../NotFoundPage/PageError404";

// Auth & Domain
import SelectDomain from "../Auth/SelectDomain";
import Login from "../Auth/LoginPage";
import ListeManagers from '../SuperAdmin/Domains/ListeManagers';
import NoDomainFound from "../Auth/NoDomainFound";
import GlobalValidateur from "../admin/Validateurs/GlobalValidateur";
import ValidationDashboard from "../Validations/ValidationDashboard";
import ValidationManagementPage from '../../pages/validation-management-page';
import Facture from "../Facturation/Facture";
import SecureDomainRoute from "../Auth/SecureDomainRoute";

// Composant qui protège les routes
import ProtectedRoute from "./ProtectedRoute";

const AppRoutes = () => {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <Routes>
        {/* Route publique - Login */}
        <Route path="/" element={
          <>
            <SignedOut>
              <Login />
            </SignedOut>
            <SignedIn>
              {/* Si déjà connecté, le Login gérera la redirection */}
              <Login />
            </SignedIn>
          </>
        } />

        {/* Routes Protégées - Toutes wrappées dans SignedIn */}
        <Route element={
          <SignedIn>
            <ProtectedRoute />
          </SignedIn>
        }>
          {/* Sélection du domaine */}
          <Route path="/page/app/select-domain" element={<SelectDomain />} />

          {/* Routes SUPER ADMIN */}
          <Route path="/Trade-Dashboard-admin" element={<Dashboard />} />
          <Route path="/admin/domain/:domainId/managers" element={<ListeManagers />} />

          {/* Routes MANAGER */}
          <Route path="/Trade-Dashboard-manager" element={<DashboardPage />} />
          <Route path="/Trade-Not-found" element={<NoDomainFound />} />
          <Route path="/Trade-Transactions" element={<TransactionsPageAdmin />} />
          <Route 
            path="/Trade-Customer/:domainUUID" 
            element={
              <SecureDomainRoute fallbackPath="/Trade-Not-found">
                <CustomerPage />
              </SecureDomainRoute>
            } 
          />
          <Route path="/Trade-Securities" element={<GestionTitle />} />
          <Route path="/Trade-Ordre" element={<OrderPageAdmin />} />
          <Route path="/Trade-Ost" element={<EventLiason />} />
          <Route path="/page/app/Component/admin/user_profile_page_view_trade_vault" element={<EditProfile />} />
          <Route path="/page/app/Component/admin/Report_page_view_trade_vault" element={<EditProfile />} />

          {/* Routes CLIENT */}
          <Route path="/Trade-Dashboard-client" element={<DashboardClient />} />
          <Route path="/page/app/customer/help_customer_trade_vault" element={<AideClient />} />
          <Route path="/page/app/customer/order_customer_trade_vault" element={<OrderPage />} />
          <Route path="/page/app/customer/transaction_customer_trade_vault" element={<TransactionsPage />} />
          <Route path="/page/app/customer/securities_lists_customer_trade_vault" element={<Securities />} />
          <Route path="/Trade-Rfi" element={<CompletRfi />} />

          {/* Routes VALIDATEUR */}
          <Route path="/Trade-Dashboard-validateur" element={<ValidationDashboard />} />
          <Route path="/Trade-Validateur" element={<GlobalValidateur />} />
          <Route path="/validation-admin" element={<ValidationManagementPage />} />

          {/* Routes FACTURATION */}
          <Route path="/Trade_Facturation" element={<Facture />} />
        </Route>

        {/* Page 404 - Accessible à tous */}
        <Route path="*" element={<PageError404 />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;